export default __webpack_public_path__ + "static/media/find-content.6a9d6b7e.mp4";